module.exports = __webpack_public_path__ + "static/assets/65441e3956a47a9f5da9d8b4225b868e.png";